import { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography } from '../../../../components/molecules/Typography';

export default function SearchInput(
  props: React.InputHTMLAttributes<HTMLInputElement>
) {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState('');
  const [error, setError] = useState<boolean>(false);

  const onSearch = () => {
    if(searchTerm.length < 3) {
      setError(true)
      return;
    }

    const baseUrl = '/search/' + searchTerm;
    navigate(baseUrl);
  };

  return (
    <Fragment>
      <input
        className={`block rounded-md border-mono-color-dark bg-mono-color-white text-sm text-mono-color-black placeholder:text-mono-color-black xs:w-[235px] lg:w-[435px]`}
        placeholder='O que você está procurando?'
        onChange={(e) => {
          if(error) {
            setError(false)
          }

          setSearchTerm(e.target.value)
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.keyCode === 13) {
            onSearch();
          }
        }}
        {...props}
      />
      {error && 
        <Typography size='mini' className='text-feedback-color-error-pure mt-2'> Digite no minimo 3 caracteres </Typography>
      }
    </Fragment>
  );
}
